import PropTypes from "prop-types";

/* Shared empty / loading / error placeholder for the results area. */
const StateMessage = ({ tone = "idle", title, text, children }) => (
  <div
    className={`c4rtn__state c4rtn__state--${tone}`}
    role={tone === "error" ? "alert" : undefined}
  >
    {tone === "loading" ? (
      <span className="c4rtn__spinner" aria-hidden="true" />
    ) : null}
    <h2 className="c4rtn__state-title">{title}</h2>
    {text ? <p className="c4rtn__state-text">{text}</p> : null}
    {children}
  </div>
);

StateMessage.propTypes = {
  tone: PropTypes.oneOf(["idle", "loading", "error", "success"]),
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  children: PropTypes.node,
};

export default StateMessage;
